import { render } from "./ReassignModal.vue?vue&type=template&id=1106c366&ts=true"
import script from "./ReassignModal.vue?vue&type=script&lang=ts"
export * from "./ReassignModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__